import { ExternalLink } from 'lucide-react';

const links = [
    { name: "Fédération Wallonie-Bruxelles", url: "http://www.federation-wallonie-bruxelles.be" },
    { name: "AFUTAB (Association Francophone des Universités Tous Âges de Belgique)", url: "http://afutab.be" },
    { name: "Syndicat d'Initiative de Barvaux", url: "https://visitwallonia.be/fr-be/content/royal-syndicat-d-initiative-de-barvaux-sur-ourthe" },
    { name: "Bibliothèque de Barvaux", url: "https://www.bibliotheques.province.luxembourg.be/iguana/www.main.cls?surl=bibliotheque_durbuy" },
];

export default function UsefulLinks() {
    return (
        <section className="py-16 bg-white">
            <div className="container mx-auto px-6">
                <div className="max-w-4xl mx-auto text-center mb-12">
                    <h2 className="text-3xl font-serif font-bold text-primary-900 mb-4">Liens Utiles</h2>
                    <div className="w-20 h-1 bg-accent-500 mx-auto rounded-full"></div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
                    {links.map((link, index) => (
                        <a
                            key={index}
                            href={link.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="group flex items-center justify-between p-6 bg-gray-50 hover:bg-white rounded-xl border border-gray-100 hover:border-accent-200 shadow-sm hover:shadow-md transition-all duration-300"
                        >
                            <span className="font-medium text-primary-900 group-hover:text-accent-600 transition-colors pr-4">
                                {link.name}
                            </span>
                            <ExternalLink
                                size={20}
                                className="text-gray-400 group-hover:text-accent-500 transition-colors transform group-hover:translate-x-1 group-hover:-translate-y-1"
                            />
                        </a>
                    ))}
                </div>
            </div>
        </section>
    );
}
